import { copy_standard_attributes } from "../../../helpers/copy_standard_attributes";
import { Snippet } from "./Snippet";
export class ScoreboardObjectiveSnippet extends Snippet {
    constructor() {
        super(...arguments);
        this.score_name = "";
        this.score_objective = "";
        this.score_value = null;
        // Shared Formatting
        this.bold = false;
        this.italic = false;
        this.underlined = false;
        this.strikethrough = false;
        this.obfuscated = false;
        this.color = "none";
        this.insertion = "";
    }
    copy() {
        let newValue = new ScoreboardObjectiveSnippet(this.id);
        newValue.score_name = this.score_name;
        newValue.score_objective = this.score_objective;
        newValue.score_value = this.score_value;
        copy_standard_attributes(this, newValue);
        return newValue;
    }
    editor_fields() {
        return [
            {
                field: "score_name",
                placeholder: "Player",
                datalistID: null,
                fieldType: "string"
            },
            {
                field: "score_objective",
                placeholder: "Objective",
                datalistID: null,
                fieldType: "string"
            }
        ];
    }
}
